
import React from "react";
import { Button } from "@/components/ui/button";
import { Heart, Share2 } from "lucide-react";

interface AgentSocialActionsProps {
  isFavorite: boolean;
  handleFavorite: () => void;
  handleShare: () => void;
}

export const AgentSocialActions: React.FC<AgentSocialActionsProps> = ({
  isFavorite,
  handleFavorite,
  handleShare,
}) => {
  return (
    <div className="flex justify-between text-sm">
      <Button 
        variant="ghost" 
        size="sm" 
        className={`flex items-center gap-1 p-1 h-auto ${isFavorite ? "text-red-500" : ""}`}
        onClick={handleFavorite}
      >
        <Heart className={`h-4 w-4 ${isFavorite ? "fill-current" : ""}`} />
        {isFavorite ? "Favorited" : "Favorite"}
      </Button>
      
      <Button 
        variant="ghost" 
        size="sm" 
        className="flex items-center gap-1 p-1 h-auto"
        onClick={handleShare}
      >
        <Share2 className="h-4 w-4" />
        Share
      </Button>
    </div>
  );
};
